var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popper-js',{attrs:{"disabled":_vm.disabled,"trigger":_vm.trigger,"options":{
        placement: _vm.placement,
        modifiers: { offset: { offset: `${_vm.offset}px` } }
    }},on:{"created":_vm.init}},[_c('div',{staticClass:"popper"},[(_vm.isContentVisible)?_vm._t("content"):_vm._e()],2),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._t("trigger")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }